var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoSlideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3544_392)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3544_392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3544_392)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0029 4.15606C13.0261 4.15606 13.8555 3.32663 13.8555 2.30349C13.8555 1.28034 13.0261 0.450928 12.0029 0.450928C10.9798 0.450928 10.1504 1.28034 10.1504 2.30349C10.1504 3.32663 10.9798 4.15606 12.0029 4.15606Z",
    fill: "#FF5722",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 18.6776C21.4754 18.6776 22.3048 17.8482 22.3048 16.825C22.3048 15.8019 21.4754 14.9724 20.4522 14.9724C19.4291 14.9724 18.5996 15.8019 18.5996 16.825C18.5996 17.8482 19.4291 18.6776 20.4522 18.6776Z",
    fill: "#FF5722",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55373 18.6776C4.57687 18.6776 5.4063 17.8482 5.4063 16.825C5.4063 15.8019 4.57687 14.9724 3.55373 14.9724C2.53059 14.9724 1.70117 15.8019 1.70117 16.825C1.70117 17.8482 2.53059 18.6776 3.55373 18.6776Z",
    fill: "#FF5722",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7505 7.17991C22.7505 5.91056 21.7213 4.88136 20.452 4.88136C19.7609 4.88136 19.1434 5.18521 18.7219 5.67041L14.1787 3.03859C14.2571 2.80825 14.3013 2.5583 14.3013 2.29855C14.3013 1.0292 13.272 0 12.0027 0C10.7334 0 9.70416 1.0292 9.70416 2.29855C9.70416 2.5583 9.74826 2.80335 9.82667 3.03369L5.28349 5.66551C4.86201 5.18521 4.24449 4.87646 3.55345 4.87646C2.2841 4.87646 1.2549 5.90566 1.2549 7.17501C1.2549 8.27282 2.02926 9.19421 3.05846 9.41965L3.06336 14.5754C2.02926 14.8009 1.25 15.7223 1.25 16.8201C1.25 18.0895 2.2792 19.1186 3.54855 19.1186C4.22488 19.1186 4.83261 18.8246 5.25408 18.359L9.81198 20.9909C9.73846 21.2162 9.69926 21.4515 9.69926 21.7015C9.69926 22.9707 10.7285 24 11.9978 24C13.2672 24 14.2963 22.9707 14.2963 21.7015C14.2963 21.4515 14.2571 21.2162 14.1837 20.9909L18.7415 18.359C19.163 18.8246 19.7707 19.1186 20.4471 19.1186C21.7165 19.1186 22.7456 18.0895 22.7456 16.8201C22.7456 15.7075 21.9467 14.7715 20.893 14.5656V9.42945C21.9517 9.2285 22.7505 8.29733 22.7505 7.17991ZM20.452 5.76843C21.2312 5.76843 21.8634 6.40065 21.8634 7.17991C21.8634 7.95915 21.2312 8.59138 20.452 8.59138C19.6727 8.59138 19.0405 7.95915 19.0405 7.17991C19.0405 6.40065 19.6776 5.76843 20.452 5.76843ZM12.0027 0.891975C12.7819 0.891975 13.4142 1.52419 13.4142 2.30345C13.4142 2.5436 13.3553 2.76904 13.2475 2.96998C13.2377 2.97978 13.2328 2.98959 13.2231 3.00429C13.2182 3.01409 13.2133 3.0239 13.2083 3.03369C12.9633 3.44047 12.5125 3.71493 12.0027 3.71493C11.2235 3.71493 10.5912 3.08271 10.5912 2.30345C10.5912 1.52419 11.2235 0.891975 12.0027 0.891975ZM2.14198 7.17991C2.14198 6.40065 2.77419 5.76843 3.55345 5.76843C4.33271 5.76843 4.96493 6.40065 4.96493 7.17991C4.96493 7.95915 4.33271 8.59138 3.55345 8.59138C2.77419 8.59138 2.14198 7.95915 2.14198 7.17991ZM3.55345 18.2365C2.77419 18.2365 2.14198 17.6042 2.14198 16.825C2.14198 16.0457 2.77419 15.4135 3.55345 15.4135C4.33271 15.4135 4.96493 16.0457 4.96493 16.825C4.96002 17.6042 4.32781 18.2365 3.55345 18.2365ZM12.0027 23.1129C11.2235 23.1129 10.5912 22.4807 10.5912 21.7015C10.5912 20.9222 11.2235 20.2899 12.0027 20.2899C12.7819 20.2899 13.4142 20.9222 13.4142 21.7015C13.4142 22.4807 12.7819 23.1129 12.0027 23.1129ZM13.7523 20.2165C13.3309 19.7215 12.7035 19.4029 12.0027 19.4029C11.3019 19.4029 10.6745 19.7166 10.2531 20.2165L5.71478 17.5993C5.80299 17.3592 5.852 17.0945 5.852 16.825C5.852 15.6929 5.03354 14.7519 3.95533 14.5608L3.95042 9.43925C5.02864 9.25302 5.852 8.30713 5.852 7.17501C5.852 6.91526 5.8079 6.6653 5.72947 6.43496L10.2727 3.80314C10.6941 4.28834 11.3166 4.59219 12.0077 4.59219C12.6986 4.59219 13.3161 4.28834 13.7376 3.80314L18.2808 6.43496C18.2024 6.6653 18.1583 6.91526 18.1583 7.17501C18.1583 8.28752 18.9571 9.22361 20.0109 9.42945V14.5656C18.9571 14.7715 18.1583 15.7026 18.1583 16.8201C18.1583 17.0945 18.2073 17.3543 18.2955 17.5944L13.7523 20.2165ZM21.8634 16.825C21.8634 17.6042 21.2312 18.2365 20.452 18.2365C19.6727 18.2365 19.0405 17.6042 19.0405 16.825C19.0405 16.0457 19.6727 15.4135 20.452 15.4135C21.2312 15.4135 21.8634 16.0457 21.8634 16.825Z",
    fill: "#FF5722",
    fillOpacity: 0.9
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3544_392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 12,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H6V17H18V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3544_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6579 15.9931H7C7 13.4094 9.1419 12 11.5 12C13.8581 12 15.7632 13.4094 16 15.9931C14.2114 16.0087 14.1053 15.9931 14.1053 15.9931",
    stroke: "#FF5722",
    strokeOpacity: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 11.4287C12.565 11.4287 13.4284 10.5652 13.4284 9.5001C13.4284 8.43498 12.565 7.57153 11.4999 7.57153C10.4347 7.57153 9.57129 8.43498 9.57129 9.5001C9.57129 10.5652 10.4347 11.4287 11.4999 11.4287Z",
    stroke: "#FF5722",
    strokeOpacity: 0.9
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3544_392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoSlideIcon);
export default __webpack_public_path__ + "static/media/geo-slide-icon.ab83967d055174cbd40a2e25f06f04ea.svg";
export { ForwardRef as ReactComponent };